export const fi = {
    languages: {
        finland: "Suomi",
        sweden: "Ruotsi",
        england: "Englanti",
        germany: "Saksa",
    },
    rowStatus: {
        new: "Uusi",
        pending: "Odottaa",
        error: "Virhe",
        active: "Aktiivinen",
        null: ""
    },
    common: {
        suppliers: "Toimittajat",
        letters: "Kirjeet",
        logout: "Kirjaudu ulos",
        servicedesk: "Asiakastuki",
        tos: "Palveluehdot",
        back: "Takaisin",
    },
    login: {
        title: "Kuluttajalaskujen ohjaus",
        username: "Käyttäjätunnus",
        password: "Salasana",
        login: "Kirjaudu sisään",
        info1: "Listaa kuluttajalaskujen tilaukset",
        info2: "Poista tilauksia",
        info3: "Muokkaa laskunsaajan tietoja",
        wrongPass: "Virheellinen käyttäjätunnus tai salasana",
        serviceDown: "Palvelu ei ole käytettävissä. Ota yhteyttä servicedesk@apixmessaging.fi.",
        accountLocked: "Turvallisuussyistä tunnus lukkiutuu 5 virheellisen kirjautumisyrityksen jälkeen. Tilisi on lukittu 5 minuutiksi."

    },
    modal: {
        confirm: "OK",
        cancel: "Peru",
        confirmSendLetter: "Haluatko varmasti lähettää {count} ilmoitusta?",
        confirmSending: "Vahvista lähetys",
        remove: "Vahvista poisto",
        stop: "Pysäytä",
    },
    letters: {
        select: "Valitse kirje",
        name: "Nimi",
        remove: "Poista",
        update: "Tallenna",
        createNew: "Luo uusi",
        create: "Luo",
        downloadPDF: "Lataa PDF",
        preview: "Esikatsele",
        updated: "Tallennettu",
        subject: "Aihe",
        exampleSentSuccessful: "Lähetetty",
        errorSendingExample: "Lähetys epäonnistui",
        errorAdding: "Tallennus epäonnistui",
        removeSuccessful: "Poistettu",
        addSuccessful: "Kirje luotu",
        sendTest: "Lähetä testisähköposti",
        confirmRemove: "Haluatko varmasti poistaa kirjeen {name}?",
        confirmTest: "Lähetä testisähköposti osoitteeseen {email}?",
        userAddressMissing: "Käyttäjältä puuttuu osoitetiedot. Päivitä osoitetiedot Laskumapin työkaluista.",
        selectFile: "Tuo kirje (PDF)"
    },
    b2c: {
        selectedInvoicer: "Laskuttaja",
        selectInvoicer: "-- Valitse laskuttaja --",
        selectAll: "Kaikki",
        notFound: "Laskunsaajaa ei löytynyt",
        delete: "Poista valitut sanomat:",
        save: "Tallenna",
        title: "RI-sanomat",
        invoicee: "Laskunsaaja",
        suppliers: "Toimittajia",
        name: "Nimi",
        add: "Lisää",
        address1: "Osoite 1",
        address2: "Osoite 2",
        businessId: "Y-tunnus",
        city: "Kaupunki",
        createdAt: "Luotu",
        updatedAt: "Päivitetty",
        hash: "Hash",
        apixId: "ApixID",
        postCode: "Postinumero",
        ibanAddress: "IBAN",
        ibanBic: "BIC",
        serviceCode: "Tilauskoodi",
        country: "Maa",
        email: "Sähköposti",
        errorUpdating: "Tallennus epäonnistui",
        errorRemoving: "Poisto epäonnistui",
        removeSuccessful: "Sanomia poistettu: {count}",
        invoices: "{count} sanoma ::: {count} sanomaa",

        
        print: "Kirje",
        status: "Tila",
        "active": "Aktiivisia",
        "new": "Uusia",
        "pending": "Odottavia",
        "error": "Virhetilassa",
        updatedSupplier: "Tallennettu",
        updatedSuppliers: "Toimittajia päivitetty: {count}",
        duplicates: "Toimittajia löytyi jo listasta: {count}",
        fetched: "Listaus päivitetty",
        confirmRemove: "Haluatko varmasti poistaa {count} sanomaa?",
        all: "Kaikki",

        checkForm: "Tarkista lomake",
        addedSupplier: "Toimittaja lisätty",
        addedSuppliers: "Toimittajia lisätty: {count}",
        operationFailed: "Toiminto epäonnistui",
        adder: "Lisää toimittaja",
        importer: "Tuo toimittajia",
        remover: "Poista toimittajia",
        sender: "Lähetä",
        main: "Tilanne",
        cantSendAsEmail: "{name} ei voi lähettää sähköpostina",

        deleteSupplier: "Poista toimittaja",
        selectLetter: "-- Valitse kirje --",
        selectDeliveryMethod: "-- Valitse toimitustapa --",
        sendLetter: "Lähetä toimittajakirje",
        invoiceCount: "Laskuja",
        lettersSent: "Kirjeitä",
        lastLetterSent: "Viimeisin kirje",
        emailsSent: "Sähköposteja",
        lastEmailSent: "Viimeisin sähköposti",
        language: "Kieli",
        importSupplier: "Tuo tiedostosta",
        examples: "Lataa mallit",
        selectFile: "Valitse tiedosto",
        selectSuppliers: "Valitse toimittajia",
        selectedSuppliers: "Valittu {count} toimittajaa",
        removeSuppliers: "Poista toimittajat",
        ofWhich: ", joista",
        inError: "virheellisiä: {count}",
        invalidAddress: "(osoitetietoja tai kieli puuttuu)",
        missingEmail: "(sähköpostiosoite tai kieli puuttuu)",
        validSuppliers: "virheettömiä: {count}",
        sending: "Lähettää",
        sent: "Lähetetty {count}/{total}",
        failedSent: "Epäonnistuneita",
        
        import: "Tuo tiedostosta",
        importInstructions1: "Tuo toimittajia excel- tai csv-tiedostosta. Y-tunnuksen perusteella jo löytyvät toimittajat jätetään lisäämättä.",
        importInstructions2: "Voit myös päivittää toimittajia y-tunnuksen perusteella valittujen sarakkeiden osalta.",
        downloadExample: "Lataa tästä excel- ja csv-mallitiedostot.",
        importSuppliers: "Tuo toimittajat tiedostosta",
        errorFileType: "Tiedostotyyppi ei kelpaa",

        importFromSystem: "Tuo järjestelmästä",
        importInstructions3: "Listasta puuttuvat toimittajat haetaan järjestelmästä.",
        importInstructions4: "Prosessi saattaa viedä useita minuutteja.",
        importSuppliersFromSystem: "Tuo toimittajat järjestelmästä",
        importingFromSystem: "Hakee toimittajia",
        overwrite: "Ylikirjoita y-tunnuksen perusteella:",
       
        texts: {
            count: "Näytetään {from}-{to} tuloksista|{count} tulosta|Yksi tulos",
            filter: "Rajaa tuloksia:",
            filterPlaceholder: "Hae",
            limit: "Sivukoko:",
            page: "Sivu:",
            noResults: "Ei tuloksia",
            filterBy: "Hae {column}illa",
            loading: "Haetaan...",
            defaultOption: "Valitse {column}",
            columns: "Sarakkeet"
        },
        statusTexts: {
            "active": "Vastaanotettu verkkolaskuja onnistuneesti",
            "new": "Ei ole vastaanotettu verkkolaskuja",
            "pending": "Informoitu, odotetaan verkkolaskuja",
            "error": "Vastaanotettu paperilasku informoinnin jälkeen"
        }
    },
}